import { FontConfig } from "../types"

export const HEADING_2_CONFIG: FontConfig = {
  title: "Headings/h2",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 24, tw: "text-[24px]" },
    lineHeight: { px: 36, tw: "leading-[36px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 40, tw: "text-[40px]" },
    lineHeight: { px: 60, tw: "leading-[60px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 56, tw: "text-[56px]" },
    lineHeight: { px: 84, tw: "leading-[84px]" },
  },
}
